import { render } from "./CategoryIndex.vue?vue&type=template&id=f1403f04"
import script from "./CategoryIndex.vue?vue&type=script&lang=js"
export * from "./CategoryIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue-project\\asset-labuhan-digital\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__